import React from 'react'

export const PageLength = ({
    handlePageLength, pageLength,
    total
}) => {

    return (
        <div className="result-foot d-flex align-items-center gap-1">
            <span> Showing </span>
            <span
                className="filter-action-count-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers"
                id="filter-count-action-dropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                {pageLength}
            </span>
            <ul
                className="filter-dropdown-menu dropdown-menu"
                aria-labelledby="filter-action-count-dropdown"
            >
                {[10, 25, 50, 100].map((value) => (
                    <li
                        key={value}
                        className="filter-dropdown-item"
                        onClick={() => handlePageLength(value)}
                    >
                        {value}
                    </li>
                ))}
            </ul>
            <span>of {total} records</span>
        </div>
  )
}
